export const menuModes = {
  vertical: 'vertical',
  horizontal: 'horizontal',
}
